import { type Level } from 'pino';

import { LS_KEYS } from '@/keys/ls_keys.ts';
import { useConfig } from '@/stores/config.store.ts';

let currentLevel: Level = 'debug';

function initLogLevel() {
  const params = new URLSearchParams(window.location.search);
  const queryLevel = params.get('logLevel') as Level;
  if (queryLevel) {
    currentLevel = queryLevel as Level;
    localStorage.setItem(LS_KEYS.LOG_LEVELS, currentLevel);
    return;
  }

  const stored = localStorage.getItem(LS_KEYS.LOG_LEVELS);
  if (stored) {
    currentLevel = stored as Level;
    return;
  }

  currentLevel = useConfig.getState().dev ? 'info' : 'error';
}

initLogLevel();

export function getLogLevel() {
  return currentLevel;
}
